export default __webpack_public_path__ + "static/media/8.1.d39c7d43.jpeg";